import { Component, OnInit } from '@angular/core';
import { DirectAddService } from '@app/modules/direct/services/direct-add.service';
import { DirectService } from '@app/modules/direct/services/direct.service';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';
import { PropertiesService } from '@app/shared/services/properties/properties.service';
import { Subject, timer } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

const loadingTextPhrases = [
  'Fetching your property details...',
  'Highlighting your top amenities...',
  'Showcasing your glowing reviews...',
  'Curating your photo gallery...',
  'Adding a touch of magic...',
  'Almost done!',
];

@Component({
  selector: 'sbnb-direct-add-properties',
  templateUrl: './direct-add-properties.component.html',
})
export class DirectAddPropertiesComponent implements OnInit {
  properties: 'all' | 'select' = 'all';
  propertyIds: number[] = [];
  allProperties: { id: number }[] = [];
  loading = false;
  loadingText = loadingTextPhrases[0];
  destroyLoading$ = new Subject<void>();
  error?: string;

  isMobile$ = this.deviceDetectionService.isMobileViewport();

  constructor(
    private readonly direct: DirectService,
    public readonly directAddService: DirectAddService,
    private readonly propertiesService: PropertiesService,
    private readonly deviceDetectionService: DeviceDetectionService
  ) {}

  ngOnInit(): void {
    this.getProperties();
  }

  getProperties() {
    this.propertiesService
      .getProperties({
        filterCriteria: [],
        paginate: false,
        transformer: 'simple',
      })
      .subscribe((res) => (this.allProperties = res.data));
  }

  createSite() {
    this.toggleLoading();
    this.direct
      .createSite({
        title: `${this.directAddService.siteDomain.subdomain}.${this.directAddService.siteDomain.domain}`,
        domain: {
          hospitable_domain: this.directAddService.siteDomain.domain,
          subdomain: this.directAddService.siteDomain.subdomain,
        },
        guest_vetting: { auto_accept: true },
        payments: { merchant_of_record: 'hospitable' },
        properties: this.properties === 'all' ? this.allProperties.map((p) => p.id) : this.propertyIds,
        include_future_properties: this.properties === 'all',
      })
      .subscribe(
        (siteId) => this.direct.getSite(siteId).subscribe((site) => this.directAddService.setSite(site)),
        (error) => {
          this.error = error.error?.message || 'We had trouble creating your site. Please try again later.';
          this.toggleLoading();
        }
      );
  }

  toggleLoading() {
    if (!this.loading) {
      this.loading = true;
      timer(0, 3500)
        .pipe(takeUntil(this.destroyLoading$), take(loadingTextPhrases.length))
        .subscribe((v) => {
          this.loadingText = loadingTextPhrases[v % loadingTextPhrases.length];
        });
    } else {
      this.loading = false;
      this.destroyLoading$.next();
    }
  }
}
